interface Props {
    /** Label rendered under the spinner. Default: "Loading…". */
    label?: string;
    /** Extra detail line — e.g. which source is being fetched. */
    sublabel?: string;
}

/**
 * Centered full-card spinner used for the initial data load and for slow
 * cross-tab fetches (Insights queries for the Requests tab). Replaces the
 * previous "Loading" pill in the topbar that was easy to miss.
 */
export function Spinner({label = 'Loading…', sublabel}: Props) {
    return (
        <div className="spinner-wrap" role="status" aria-live="polite">
            <div className="spinner" aria-hidden />
            <div className="spinner-label">{label}</div>
            {sublabel && <div className="spinner-sub">{sublabel}</div>}
        </div>
    );
}
